
import { BrowserRouter as Router } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

// eslint-disable-next-line camelcase
import Layout from "./_Layout";
import Routes from "./_routes";
import { AppDispatch } from "./app/store";
import { getMarketHolidays } from "./utils/datetimehandler";
import useSetupAxios from "./hooks/useSetupAxios";

const App = () => {
  useSetupAxios();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (process.env.REACT_APP_ACCESS_TYPE?.trim() === "internal") console.log(`Version -> ${process.env.REACT_APP_TAG_VERSION}`)
    getMarketHolidays(dispatch)
  }, [])

  return (
    <Router>
      <Layout>
        <Routes />
      </Layout>
    </Router>
  );
};

export default App;